import React from 'react';

interface MetricChipProps {
  /** Metric label (e.g., "DT") */
  label: string;
  /** Metric value (e.g., "82ms") */
  value: string | number;
  /** Color of the value text */
  color?: string;
  /** Unit suffix (e.g., "ms") */
  unit?: string;
  /** Size variant */
  size?: 'sm' | 'md' | 'lg';
}

/**
 * MetricChip — Small inline chip displaying a metric label and value.
 */
export default function MetricChip({
  label,
  value,
  color = '#e8e8e8',
  unit = '',
  size = 'sm',
}: MetricChipProps) {
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5 gap-1',
    md: 'text-sm px-3 py-1 gap-1.5',
    lg: 'text-base px-4 py-1.5 gap-2',
  };

  return (
    <span
      className={`
        inline-flex items-center font-mono rounded-full
        bg-bg-surface/60 border border-bg-surface
        ${sizeClasses[size]}
      `}
    >
      <span className="text-txt-muted">{label}:</span>
      <span className="font-medium" style={{ color }}>
        {value}
        {unit && <span className="text-txt-muted ml-0.5">{unit}</span>}
      </span>
    </span>
  );
}
